<template>
  <div>
    <el-button @click="$router.back()" style="margin-bottom:16px;">← 返回</el-button>
    <h2>设备详情</h2>

    <el-card class="info-card" v-if="detail">
      <el-descriptions :column="3" border>
        <el-descriptions-item label="设备编号">{{ detail.deviceNo || detail.deviceId }}</el-descriptions-item>
        <el-descriptions-item label="绑定账户数">{{ detail.bindAccountCount }}</el-descriptions-item>
        <el-descriptions-item label="是否共享">
          <el-tag v-if="detail.isShared === 1" type="warning" size="small">共享设备</el-tag>
          <span v-else>否</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <div v-if="detail && detail.isShared === 1" class="warning-tip">
      提示：该设备为共享设备，检测数据可能由多个账户共同产生，统计结果仅供参考。
    </div>

    <h3 style="margin-top:16px;">各试剂检测明细</h3>
    <el-table :data="detail?.reagentItems || []" border style="width:100%;">
      <el-table-column prop="reagentName" label="试剂名称" min-width="120" />
      <el-table-column prop="monthTestTimes" label="本月检测次数" width="120" align="center" />
      <el-table-column prop="totalTestTimes" label="累计检测次数" width="120" align="center" />
      <el-table-column label="风险状态" width="100" align="center">
        <template v-slot="scope">
          <el-tag :type="getRiskTagType(scope.row.riskStatus)" size="small">
            {{ getRiskText(scope.row.riskStatus) }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getDeviceDetail } from "@/api/reagentMonitor";

export default {
  data() {
    return {
      detail: null,
    };
  },
  created() {
    const deviceId = this.$route.params.deviceId;
    if (deviceId) {
      this.loadDetail(deviceId);
    }
  },
  methods: {
    async loadDetail(deviceId) {
      try {
        const now = new Date();
        const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        const res = await getDeviceDetail({ deviceId, startMonth: month, endMonth: month });
        if (res.code === 200) {
          this.detail = res.data;
        }
      } catch (e) { console.error(e); }
    },
    getRiskTagType(status) {
      if (status === "HIGH") return "danger";
      if (status === "MEDIUM") return "warning";
      return "success";
    },
    getRiskText(status) {
      if (status === "HIGH") return "异常";
      if (status === "MEDIUM") return "注意";
      return "正常";
    },
  },
};
</script>

<style scoped>
.info-card { margin-bottom: 16px; }
.warning-tip {
  margin-top: 16px;
  padding: 12px 16px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  color: #ad6800;
  border-radius: 4px;
}
</style>
